<div class="wrapper selenium-school-selector">
    <ng-select
        [items]="items"
        bindLabel="name"
        dropdownPosition="bottom"
        [multiple]="false"
        [hideSelected]="false"
        [searchable]="false"
        [clearable]="false"
        [markFirst]="true"
        placeholder="Select a school"
        [(ngModel)]="selectedItem"
        (change)="selectedItemChange.emit(selectedItem)"
        class="dropdown"
    >
    </ng-select>
    <div class="school-label">School</div>
</div>
